import React from 'react';
const SvgDocument = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 36 36", focusable: false }, props),
    React.createElement("path", { d: "M21.83 2H6v32h24V10.17zM10 30V6h10v6h6v18z" })));
export default SvgDocument;
//# sourceMappingURL=Document.js.map